import React from "react";

function Header() {
  return (
    <header>
      <h1>Note it !</h1>
    </header>
  );
}

export default Header;
